import React, { useEffect, useState } from 'react';
import {
  Form,
  Space,
  Select,
  Col,
  // Alert,
  // Checkbox,
  Row,
  Radio,
  Divider,
  Input,
  // message,
  DatePicker
} from 'antd';
import CustomButton from '@/common/CustomButton';
import CustomModal from '@/common/CustomModal';
import FormItem from '@/common/FormItem';
// import { ExclamationCircleFilled } from '@ant-design/icons';
// CaretDownFilled
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getAllSbgs, getAllSbus } from '../../../settings/redux/slice';
import { getCOSTNum } from '../../redux/slice';
const Option = Select;
// import { numFormating } from 'utilities/helpers';
import styles from './index.module.less';
import dayjs from 'dayjs';
import moment from 'moment';

const AddStandardModal = ({
  // setSearchSubCategory,
  // setCategoryId,
  // onSearchSubCategory,
  form,
  // onSearchCategory,
  // selectedStatus,
  // setSelectedStatus,
  handleStandardCancel,
  isStandardModalVisible,
  loading,
  // pricebrackets,
  // categories,
  // handleCategory,
  // subcategories,
  handleSearchstandard,
  type,
  // projects,
  // onSearch,
  // onSelectProject,
  // onSelectBU,
  // onSearchbu,
  // bu
  // handleSubCategory
  // setCategory,
  category,
  // locations,
  plants,
  functions,
  onCategoryChange,
  subcategory,
  // activity,
  // companyid,
  // setCompanyId,
  setSearch,
  setDepartmentt,
  setPlant,
  // get_IONumbers,
  // setIonum,
  get_COSTNumber,
  // setCostnum,
  // setIOSearch,
  // setCOSTSearch,
  // setactivitySearch,
  setDepartmentSearch
  // get_businesscasejustification
  // ionum
}) => {
  const [selectedPlant, setSelectedPlant] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const dispatch = useDispatch();
  const params = useParams();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [costCenters, setCostCenters] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const handleGetAllSBUs = () => {
    dispatch(getAllSbus());
  };

  const handleGetAllSbgs = () => {
    dispatch(getAllSbgs());
  };
  useEffect(() => {
    handleGetAllSBUs();
    handleGetAllSbgs();
  }, []);
  // console.log('activity', params.id);

  console.log('costCenters', costCenters);
  // console.log('type', type);
  localStorage.setItem('type', type);
  const onFinish = (values) => {
    values['type'] = type;
    handleSearchstandard(values);
    localStorage.setItem(
      'apiCallValues',
      JSON.stringify({
        // unit_id: values.unit_id,
        type: type,
        category_id: values.category_id,
        sub_category_id: values.sub_category_id,
        flow_id: params.id,
        plant_id: values.plant_id,
        department_id: values.department_id,
        nfa_amount: values.nfa_amount,
        business_case_justification: values.business_case_justification,
        balance_amount: values.balance_amount,
        // io_no_id: values.io_no_id,
        // io_amount: values.io_amount,
        // io_balance_amount: values.io_balance_amount,
        cost_center: values.cost_center,
        // activity: values.activity_id,
        activity: values.activity,
        // activity_id: values.activity_id,
        activity_id: values.activity,
        payback_period: values.payback_period,
        remarks: values.remarks,
        cost_centr_id: values.cost_centr_id,
        // cost_center_amount: values.cost_center_amount,
        // cost_center_balance_amount: values.cost_center_balance_amount

        // project_id: values.project_id || null
        // project_start_date: values.project_start_date,
        // project_end_date: values.project_end_date,
        project_start_date: values.project_start_date
          ? values.project_start_date.format('YYYY-MM-DD')
          : null,
        project_end_date: values.project_end_date
          ? values.project_end_date.format('YYYY-MM-DD')
          : null,
        project_objective: values.project_objective,
        name: values.name,
        email: values.email
      })
    );
    console.log('values', values);
  };

  // useEffect(() => {
  //   const savedData = localStorage.getItem('apiCallValues');
  //   if (savedData) {
  //     const parsed = JSON.parse(savedData);
  //     form.setFieldsValue({
  //       ...parsed,
  //       project_start_date: parsed.project_start_date
  //         ? dayjs(parsed.project_start_date).format('YYYY-MM-DD')
  //         : null,
  //       project_end_date: parsed.project_end_date
  //         ? dayjs(parsed.project_end_date).format('YYYY-MM-DD')
  //         : null
  //     });

  //     // ✅ Re-enable category selection
  //     if (parsed.plant_id) setSelectedPlant(parsed.plant_id);
  //     if (parsed.department_id) setSelectedDepartment(parsed.department_id);

  //     // ✅ Restore category name so validation & UI logic work
  //     if (parsed.category_id && Array.isArray(category)) {
  //       const selectedCategoryObj = category.find(
  //         (cat) => cat.id === parsed.category_id
  //       );
  //       if (selectedCategoryObj) {
  //         setSelectedCategory(selectedCategoryObj.category_name);
  //       }
  //     }
  //     // Update local state for startDate (needed for min date on endDate input)
  //     setStartDate(project_start_date);
  //   }
  // }, [form, category]);

  useEffect(() => {
    const savedData = localStorage.getItem('apiCallValues');
    if (savedData) {
      const parsed = JSON.parse(savedData);

      // Convert dates to 'YYYY-MM-DD' for input[type="date"]
      // const projectStartDate = parsed.project_start_date
      //   ? dayjs(parsed.project_start_date).format('YYYY-MM-DD')
      //   : null;
      // const projectStartDate = parsed.project_start_date
      //   ? dayjs(parsed.project_start_date)
      //   : null;
      // const projectStartDate =
      //   parsed.project_start_date && dayjs(parsed.project_start_date).isValid()
      //     ? dayjs(parsed.project_start_date)
      //     : null;
      const projectStartDate = parsed.project_start_date
        ? moment(parsed.project_start_date, 'YYYY-MM-DD')
        : null;
      // const projectEndDate = parsed.project_end_date
      //   ? dayjs(parsed.project_end_date).format('YYYY-MM-DD')
      //   : null;
      // const projectEndDate = parsed.project_end_date
      //   ? dayjs(parsed.project_end_date)
      //   : null;
      // const projectEndDate =
      //   parsed.project_end_date && dayjs(parsed.project_end_date).isValid()
      //     ? dayjs(parsed.project_end_date)
      //     : null;
      const projectEndDate = parsed.project_end_date
        ? moment(parsed.project_end_date, 'YYYY-MM-DD')
        : null;

      form.setFieldsValue({
        ...parsed,
        project_start_date: projectStartDate,
        project_end_date: projectEndDate
        // project_start_date: values.project_start_date?.format('YYYY-MM-DD'),
        // project_end_date: values.project_end_date?.format('YYYY-MM-DD')
      });

      if (parsed.plant_id) setSelectedPlant(parsed.plant_id);
      if (parsed.department_id) setSelectedDepartment(parsed.department_id);

      if (parsed.category_id && Array.isArray(category)) {
        const selectedCategoryObj = category.find(
          (cat) => cat.id === parsed.category_id
        );
        if (selectedCategoryObj) {
          setSelectedCategory(selectedCategoryObj.category_name);
        }
      }

      // Update startDate state for min restriction on end date
      setStartDate(projectStartDate);
    }
  }, [form, category]);

  // Handle Category Change
  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    // setSelectedCategory(selectedValue); // Update local state
    console.log('selectedValue', selectedValue);

    // Find the category object from the category array using the selected id
    const selectedCategoryObj = category.find(
      (cat) => cat.id === selectedValue
    );
    form.setFieldsValue({ sub_category_id: undefined });
    // Get the category name like 'Capex' or 'Opex'
    const selectedCategoryName = selectedCategoryObj
      ? selectedCategoryObj.category_name
      : '';
    console.log('selectedCategoryName', selectedCategoryName);

    // Update the state with the selected category id
    // setSelectedCategory(selectedCategoryName);
    setSelectedCategory(selectedCategoryName);
    // setSelectedSubCategory(null); // Reset sub-category to null

    // onCategoryChange(selectedValue);
    if (onCategoryChange) {
      onCategoryChange(selectedValue);
    }

    // // ✅ Revalidate NFA Amount when Category changes
    // form.validateFields(['nfa_amount']);

    // ✅ Option 1: Automatically trigger validation (your current approach)
    // form.validateFields(['nfa_amount']);

    // ✅ Option 2: Manually show an error without triggering validation
    if (!selectedCategoryObj) {
      form.setFields([
        {
          name: 'nfa_amount',
          errors: ['Please select a valid category before entering NFA amount']
        }
      ]);
    } else {
      // Clear previous error if any
      form.setFields([
        {
          name: 'nfa_amount',
          errors: []
        }
      ]);
    }
  };
  console.log('SelectedCategory', selectedCategory);

  // const handleCompany = (value) => {
  //   setCompanyId(value);
  //   // setCompany(value);
  // };
  const handlePlant = (value) => {
    setSelectedPlant(value);
    setPlant(value);
  };

  const handleDepartmentt = (value) => {
    setSelectedDepartment(value);
    setDepartmentt(value);
  };
  const handleSearch = (value) => {
    setSearch(value);
  };

  // const handleIOSearch = (value) => {
  //   setIOSearch(value);
  // };
  // const handlecostSearch = (value) => {
  //   setCOSTSearch(value);
  // };
  // const handleActivitySearch = (value) => {
  //   setactivitySearch(value);
  // };
  const handleDepartmenttSearch = (e) => {
    setDepartmentSearch(e);
  };

  // localStorage.setItem('type', type);

  const validateNfaAmount = (getFieldValue, selectedCategory) => (_, value) => {
    const num = parseFloat(value?.toString().replace(/,/g, ''));

    // Only run rule for Capex
    if (selectedCategory === 'Capex') {
      if (!num || num < 1500000) {
        return Promise.reject(
          new Error('For Capex, NFA amount must be ₹15,00,000 or more')
        );
      }
    }

    return Promise.resolve();
  };

  const fetchCostCenters = async (plantId, departmentId) => {
    try {
      let payload = {
        plant_id: plantId,
        department_id: departmentId,
        user: 'user'
      };
      dispatch(getCOSTNum(payload));
      // Replace this with your actual API call or redux dispatch
      // const response = await fetch(
      //   getCOSTNum`?plant_id=${plantId}&department_id=${departmentId}`
      // );
      // const data = await response.json();
      // setCostCenters(data);
    } catch (error) {
      console.error('Failed to fetch cost centers:', error);
      setCostCenters([]);
    }
  };

  // console.log('selectedPlant', selectedPlant);
  // console.log('selectedDepartment', selectedDepartment);
  // Watch plant and department change
  useEffect(() => {
    if (selectedPlant && selectedDepartment) {
      fetchCostCenters(selectedPlant, selectedDepartment);
    }
  }, [selectedPlant, selectedDepartment]);

  const isCategoryDisabled = !(selectedPlant && selectedDepartment);
  return (
    <CustomModal
      // width={1000}
      footer={null}
      onCancel={handleStandardCancel}
      visible={isStandardModalVisible}
      title={`Initiate ${type} DoA envelope`}
      type={'standard'}
    >
      <Form
        form={form}
        layout="vertical"
        className="ant-form ant-form-vertical"
        onFinish={onFinish}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Plant"
              name="plant_id"
              rules={[{ required: true, message: 'Select plant' }]}
            >
              <Select
                placeholder="Select plant"
                onChange={handlePlant}
                showSearch
                optionFilterProp="children"
                onSearch={handleSearch}
              >
                {/* <Option value="location1">Location 1</Option>
                <Option value="location2">Location 2</Option> */}
                {plants.map((plant) => (
                  <Option key={plant.id} value={plant.id}>
                    {plant.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Department"
              name="department_id"
              rules={[{ required: true, message: 'Select department' }]}
            >
              <Select
                placeholder="Select department"
                onChange={handleDepartmentt}
                showSearch
                optionFilterProp="children"
                onSearch={handleDepartmenttSearch}
              >
                {/* <Option value="function1">Function 1</Option>
                <Option value="function2">Function 2</Option> */}
                {functions.map((functions) => (
                  <Option key={functions.id} value={functions.id}>
                    {functions.function_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Category"
              name="category_id"
              rules={[{ required: true, message: 'Select a Category type' }]}
            >
              <Radio.Group
                onChange={handleCategoryChange}
                value={selectedCategory}
                disabled={isCategoryDisabled}
              >
                {/* <Radio value="Capex">Capex</Radio>
                <Radio value="P2P">P2P</Radio> */}
                {category.map((cat) => (
                  <Radio key={cat.id} value={cat.id}>
                    {cat.category_name}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Sub Category"
              name="sub_category_id"
              rules={[{ required: true, message: 'Select sub-category' }]}
            >
              <Select placeholder="Select sub-category">
                {/* <Option value="location1">Location 1</Option>
                <Option value="location2">Location 2</Option> */}
                {subcategory.map((subcategory) => (
                  <Option key={subcategory.id} value={subcategory.id}>
                    {subcategory.sub_category_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {/*  */}

          <Col span={12}>
            <Form.Item
              label="NFA Amount"
              name="nfa_amount"
              rules={[
                {
                  required: true,
                  message: 'NFA amount is required'
                },
                {
                  pattern: /^\d*\.?\d*$/,
                  message: 'Only numeric values are allowed'
                },
                {
                  validator: validateNfaAmount(
                    form.getFieldValue,
                    selectedCategory
                  )
                }
              ]}
            >
              <Input
                placeholder="Enter NFA amount"
                // onChange={handleNfaAmountChange}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Business Case justification"
              name="business_case_justification"
              rules={[
                {
                  required: true,
                  message: 'Please select business case justification'
                }
              ]}
            >
              {/* <Select placeholder="Select business case justification">
                {get_businesscasejustification.map((bcj) => (
                  <Option key={bcj.id} value={bcj.id}>
                    {bcj.name}
                  </Option>
                ))}
              </Select> */}
              <Input placeholder="Enter business case justification" />
            </Form.Item>
          </Col>
          {/* Conditionally Render Based on Category */}
          {selectedCategory === 'Capex' && (
            <>
              <Col span={12}>
                <Form.Item
                  label="Activity"
                  // name="activity_id"
                  name="activity"
                  rules={[{ required: true, message: 'Select activity' }]}
                >
                  {/* <Select
                    placeholder="Select activity"
                    onChange={handleCompany}
                    showSearch
                    optionFilterProp="children"
                    onSearch={handleActivitySearch}
                  >
                    {activity.map((activity) => (
                      <Option key={activity.id} value={activity.id}>
                        {activity.name}
                      </Option>
                    ))}
                  </Select> */}
                  <Input placeholder="Enter activity" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Payback Period"
                  name="payback_period"
                  rules={[
                    {
                      required: true,
                      message: 'Select payback period'
                    }
                  ]}
                >
                  {/* <DatePicker
                    placeholder="Enter payback period"
                    style={{ width: '100%' }}
                  /> */}
                  <Input placeholder="Enter payback period" />
                </Form.Item>
              </Col>
            </>
          )}

          {selectedCategory === 'Opex' && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Cost Center"
                  // name="cost_center"
                  name="cost_centr_id"
                  rules={[
                    { required: true, message: 'Please enter cost center' }
                  ]}
                >
                  <Select
                    placeholder="Select cost center"
                    // onChange={handleionum}
                    // onChange={handleCostNumChange}
                    showSearch
                  >
                    {get_COSTNumber.map((get_COSTNumbe) => (
                      <Option key={get_COSTNumbe.id} value={get_COSTNumbe.id}>
                        {get_COSTNumbe.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </>
          )}

          {/* Project Start Date and End Date */}

          <Col span={12}>
            <Form.Item
              label="Project Start Date"
              name="project_start_date"
              rules={[
                {
                  required: true,
                  message: 'Please select project start date'
                }
              ]}
            >
              <DatePicker
                placeholder="Select project start date"
                style={{ width: '100%' }}
                onChange={(date) => setStartDate(date)}
                disabledDate={(current) =>
                  current && current > dayjs().endOf('day')
                }
              />
            </Form.Item>
            {/* <Form.Item
              label="Project Start Date"
              name="project_start_date"
              rules={[
                { required: true, message: 'Please select project start date' }
              ]}
            >
              <Input
                type="text"
                placeholder="Select project start date"
                onFocus={(e) => (e.target.type = 'date')}
                onBlur={(e) => {
                  if (!e.target.value) e.target.type = 'text';
                }}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Item> */}
          </Col>
          <Col span={12}>
            <Form.Item
              label="Project End Date"
              name="project_end_date"
              rules={[
                {
                  required: true,
                  message: 'Please select project end date'
                }
              ]}
            >
              <DatePicker
                placeholder="Select project end date"
                style={{ width: '100%' }}
                disabledDate={(current) =>
                  startDate &&
                  current &&
                  current < dayjs(startDate).startOf('day')
                }
              />
            </Form.Item>
            {/* <Form.Item
              label="Project End Date"
              name="project_end_date"
              rules={[
                { required: true, message: 'Please select project end date' }
              ]}
            >
              <Input type="date" disabled={!startDate} min={startDate} />
            </Form.Item> */}
          </Col>
          <Col span={12}>
            <Form.Item
              label="Project Objective"
              name="project_objective"
              rules={[
                {
                  required: true,
                  message: 'Please enter project objective'
                }
              ]}
            >
              <Input placeholder="Enter project objective" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <h2
              className={`${styles.projectobjectives}`}
              // className="ant-form ant-form-vertical"
            >
              Project responsible person details
            </h2>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please enter name'
                }
              ]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="E-mail"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter email'
                }
              ]}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="Remarks"
              name="remarks"
              rules={[
                {
                  required: false,
                  message: 'Please enter remarks'
                }
              ]}
            >
              <Input
                placeholder="Enter remarks"
                // onChange={handleRemarksChange}
              />
            </Form.Item>
          </Col>
        </Row>

        <Divider />

        <FormItem className={`${styles.footerstyle}`}>
          <Space>
            <CustomButton htmlType="button" onClick={handleStandardCancel}>
              Cancel
            </CustomButton>
            <CustomButton type="primary" htmlType="submit" loading={loading}>
              Next
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
};

export default AddStandardModal;
